import * as React from 'react';
import './index.css';
import {Link, useParams} from 'react-router-dom';
import Table from "../../Table";
import Modal from "../../Modal";
import {useCallback, useEffect, useState} from "react";
import {
    addDocumentToClient,
    createDocument,
    deleteClientDocument,
    disableClient,
    enableClient,
    getClient,
    getCustomerDocumentKey,
    getDocumentKey,
    getEsignProfiles,
    getFile,
    getTemplates,
    pendingCustomerDocumentOnClient,
    pendingCustomerDocumentOnClientReminder,
    sendPaymentReceipt,
    shareDocumentWithClient,
    updateClient,
    uploadFile
} from "../../../api";
import dateFormat from "dateformat";
import {
    Attendance,
    ClientDocument,
    FileResponse,
    LegacyDocument,
    LegacyNote,
    Template,
    Transaction
} from "../../../types";

var format = require('date-format');


const ViewClient: React.FunctionComponent = () => {

    const coreApiHost = (window.location.hostname === "localhost")
        ? (window.location.protocol + '//' + window.location.hostname + ":8090")
        : (window.location.protocol + '//' + window.location.host);

    let esignEndpoint = (window.location.protocol + '//' + window.location.hostname);
    if (window.location.hostname === "34.201.190.181") {
        esignEndpoint = "http://34.201.190.181:3005";
    }
    if (window.location.hostname === "localhost") {
        esignEndpoint = "http://localhost";
    }

    if (window.location.hostname === "test.promises12data.com" || window.location.hostname === "promises12data.com") {
        esignEndpoint = "https://esign.promises12data.com";
    }

    const [showUploadFileModal, setShowUploadFileModal] = useState(false);
    const {clientId} = useParams();
    const currencyFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});
    const [id, setId] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [ssn, setSsn] = useState("");
    const [dlState, setDlState] = useState("");
    const [dlNumber, setDlNumber] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [telephone, setTelephone] = useState("");
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [stateCode, setStateCode] = useState("");
    const [zip, setZip] = useState("");
    const [addressId, setAddressId] = useState("");
    const [balance, setBalance] = useState(0);
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [disabled, setDisabled] = useState(false);
    const [attendances, setAttendances] = useState<Attendance[]>([])

    const [assessmentDate, setAssessmentDate] = useState("");
    const [assessmentTime, setAssessmentTime] = useState("");
    const [recommendedHours, setRecommendedHours] = useState("");
    const [totalHoursAttended, setTotalHoursAttended] = useState("");
    const [absences, setAbsences] = useState("");

    const [editMode, setEditMode] = useState(false);
    const [doReload, setDoReload] = useState(false);

    const [templates, setTemplates] = useState<Template[]>();
    const [documents, setDocuments] = useState<ClientDocument[]>();
    const [legacyDocuments, setLegacyDocuments] = useState<LegacyDocument[]>();
    const [legacyNotes, setLegacyNotes] = useState<LegacyNote[]>();
    const [form, setForm] = useState("");
    const [profile, setProfile] = useState("");

    const [artifact, setArtifact] = useState();
    const [artifactUploading, setArtifactUploading] = useState(false);
    const [doUpload, setDoUpload] = useState(false);

    const [receiptLoading, setReceiptLoading] = useState("");
    const [signReminderLoading, setSignReminderLoading] = useState("")

    const [clientDiagnosis, setClientDiagnosis] = useState("")
    const [drugTestDueDate, setDrugTestDueDate] = useState("");

    const load = useCallback(() => {
        getClient(clientId)
            .then((c) => {
                setId(c.id);
                setFirstName(c.firstName);
                setLastName(c.lastName);
                setEmail(c.email);
                setSsn(c.socialsecurityNumber);
                setDlState(c.driverslicenseState);
                setDlNumber(c.driverslicenseNumber);
                setDateOfBirth(c.dateofBirth);
                setTelephone(c.telephoneNumber);
                setAddressLine1(c.address.addressLine1);
                setAddressLine2(c.address.addressLine2);
                setCity(c.address.city);
                setStateCode(c.address.state);
                setZip(c.address.zip);
                setAddressId(c.address.uuid || "")
                if (c.dateTimeofAssessment !== undefined) {
                    setAssessmentDate(dateFormat(format.parse("yyyy-MM-ddThh:mm:ss", c.dateTimeofAssessment), "yyyy-mm-dd"));
                    setAssessmentTime(dateFormat(format.parse("yyyy-MM-ddThh:mm:ss", c.dateTimeofAssessment), "HH:MM"));
                }
                setRecommendedHours(c.recommendedHours);
                setBalance(c.balance);
                setTransactions(c.transactions)
                setDisabled(c.disabled);
                setAttendances(c.attendances);
                setTotalHoursAttended(c.totalHoursAttended);
                setAbsences(c.absences);
                setDocuments(c.documents);
                setLegacyDocuments(c.legacyDocuments);
                setLegacyNotes(c.legacyNotes);
                setClientDiagnosis(c.clientDiagnosis);
                setDrugTestDueDate(c.drugTestDueDate);
            }).catch((e) => {
            console.log(e);
        })


        getEsignProfiles()
            .then((ps) => {
                let profile = ps.filter((p) => p.name === "Promises12")[0];
                setProfile(profile.uuid);
                getTemplates(profile.uuid)
                    .then((tz) => {
                        setTemplates(tz.filter((t) => t.tag === "form"));
                    })
            })
            .catch((e) => {
                console.log(e);
            })

    }, [clientId]);

    useEffect(() => {
        load()
    }, [load]);

    useEffect(() => {
        if (doReload) {
            setDoReload(false);
            load()
        }
    }, [doReload, load]);

    const doEdit = () => {
        updateClient(clientId, {
            address: {
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                city: city,
                state: stateCode,
                zip: zip,
                uuid: addressId
            },
            firstName: firstName,
            lastName: lastName,
            socialsecurityNumber: ssn,
            driverslicenseNumber: dlNumber,
            driverslicenseState: dlState,
            dateofBirth: dateOfBirth,
            telephoneNumber: telephone,
            email: email,
            dateTimeofAssessment: assessmentDate + "T" + assessmentTime,
            recommendedHours: recommendedHours,
            clientDiagnosis: clientDiagnosis,
            drugTestDueDate: drugTestDueDate
        }).then((c) => {
            setEditMode(false);
            load();
        }).catch((e) => console.log(e));
    }

    const doQuickAddForm = (formName: string) => {
        if (isFormComplete(formName)) {
            return;
        }
        const filter = templates?.filter((d) => d.name === formName);
        if (filter !== undefined && filter.length > 0 && profile !== undefined && profile !== "") {
            createDocument(profile, {
                template: {
                    uuid: filter[0].uuid
                },
                fields: [{
                    name: "fullName",
                    value: firstName + " " + lastName
                }, {
                    name: "firstName",
                    value: firstName
                }, {
                    name: "lastName",
                    value: lastName
                }, {
                    name: "id",
                    value: id
                }, {
                    name: "email",
                    value: email
                }, {
                    name: "ssn",
                    value: ssn
                }, {
                    name: "driversLicenseState",
                    value: dlState
                }, {
                    name: "driversLicenseNumber",
                    value: dlNumber
                }, {
                    name: "dateOfBirth",
                    value: dateOfBirth
                }, {
                    name: "telephone",
                    value: telephone
                }, {
                    name: "addressLine1",
                    value: addressLine1
                }, {
                    name: "addressLine2",
                    value: addressLine2
                }, {
                    name: "city",
                    value: city
                }, {
                    name: "stateCode",
                    value: stateCode
                }, {
                    name: "zip",
                    value: zip
                }, {
                    name: "balance",
                    value: balance + ""
                }, {
                    name: "assessmentDate",
                    value: assessmentDate
                }, {
                    name: "assessmentTime",
                    value: assessmentTime
                }, {
                    name: "recommendedHours",
                    value: recommendedHours
                }, {
                    name: "totalHoursAttended",
                    value: totalHoursAttended
                }, {
                    name: "absences",
                    value: absences
                }]
            }).then((d) => {
                const esignUrl = esignEndpoint + '/s/' + profile + "/" + d.uuid;

                getDocumentKey(profile, d.uuid)
                    .then((k) => {
                        addDocumentToClient(clientId, {
                            type: "FORM",
                            name: d.template.name,
                            url: esignUrl,
                            description: "Client form",
                            status: "PENDING"
                        }).then((cd) => {
                            const completeDocUrl = (window.location.protocol + '//' + window.location.host) + "/m/clients/" + clientId + "/documents/complete/" + cd.uuid;
                            window.open(esignUrl + "?document_key=" + k.uuid + "&redirect_uri=" + completeDocUrl, '_self');
                        })
                    })
                    .catch((e) => console.log(e))


            })
        }
    }

    const doAddForm = () => {
        if (form !== undefined && form !== "" && profile !== undefined && profile !== "") {
            createDocument(profile, {
                template: {
                    uuid: form
                },
                fields: [{
                    name: "fullName",
                    value: firstName + " " + lastName
                }, {
                    name: "firstName",
                    value: firstName
                }, {
                    name: "lastName",
                    value: lastName
                }, {
                    name: "id",
                    value: id
                }, {
                    name: "email",
                    value: email
                }, {
                    name: "ssn",
                    value: ssn
                }, {
                    name: "driversLicenseState",
                    value: dlState
                }, {
                    name: "driversLicenseNumber",
                    value: dlNumber
                }, {
                    name: "dateOfBirth",
                    value: dateOfBirth
                }, {
                    name: "telephone",
                    value: telephone
                }, {
                    name: "addressLine1",
                    value: addressLine1
                }, {
                    name: "addressLine2",
                    value: addressLine2
                }, {
                    name: "city",
                    value: city
                }, {
                    name: "stateCode",
                    value: stateCode
                }, {
                    name: "zip",
                    value: zip
                }, {
                    name: "balance",
                    value: balance + ""
                }, {
                    name: "assessmentDate",
                    value: assessmentDate
                }, {
                    name: "assessmentTime",
                    value: assessmentTime
                }, {
                    name: "recommendedHours",
                    value: recommendedHours
                }, {
                    name: "totalHoursAttended",
                    value: totalHoursAttended
                }, {
                    name: "absences",
                    value: absences
                }]
            }).then((d) => {
                const esignUrl = esignEndpoint + '/s/' + profile + "/" + d.uuid;

                getDocumentKey(profile, d.uuid)
                    .then((k) => {
                        addDocumentToClient(clientId, {
                            type: "FORM",
                            name: d.template.name,
                            url: esignUrl,
                            description: "Client form",
                            status: "PENDING"
                        }).then((cd) => {
                            const completeDocUrl = (window.location.protocol + '//' + window.location.host) + "/m/clients/" + clientId + "/documents/complete/" + cd.uuid;
                            window.open(esignUrl + "?document_key=" + k.uuid + "&redirect_uri=" + completeDocUrl, '_self');
                        })
                    })
                    .catch((e) => console.log(e))


            })
        }
    }

    const doOpenDocument = (id: string, status: string, url: string) => {
        const docValues = url.substring(url.indexOf("/s/")).split("/");
        getDocumentKey(profile, docValues[3])
            .then((k) => {
                const esignUrl = esignEndpoint + '/s/' + profile + "/" + docValues[3];
                if (status.toLowerCase() !== "pending") {
                    const completeDocUrl = (window.location.protocol + '//' + window.location.host) + "/m/clients/view/" + clientId;
                    window.open(esignUrl + "?document_key=" + k.uuid + "&redirect_uri=" + completeDocUrl, '_self');
                } else {
                    //m/clients/1bfe3b63-7497-4341-81c2-6040c7abecad/documents/complete/88b25494-cff2-4354-8beb-23378b9605b7
                    const completeDocUrl = (window.location.protocol + '//' + window.location.host)
                        + "/m/clients/" + clientId + "/documents/complete/" + id;
                    window.open(esignUrl + "?document_key=" + k.uuid + "&redirect_uri=" + completeDocUrl, '_self');
                }
            })
            .catch((e) => {
                console.log(e)
            })
    }

    const doDownloadFile = (url: string, name: string) => {
        getFile(url)
            .then((r) => {
                if (r.ok) {
                    return r.blob();
                }
            })
            .then((data) => {
                var url = window.URL.createObjectURL(data),
                    anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = name;
                anchor.click();
                window.URL.revokeObjectURL(url);
                anchor.remove();
            })
    }

    useEffect(() => {
        if (artifact !== undefined && doUpload) {
            setArtifactUploading(true);
            uploadFile(clientId, artifact)
                .then((value) => {
                    load();
                })
                .finally(() => {
                    setDoUpload(false);
                    setArtifact(undefined);
                    setArtifactUploading(false);
                });
        }
    }, [artifact, doUpload]);

    const isFormComplete = (formName: string) => {
        const filter = documents?.filter((d) => d.name === formName);
        return filter !== undefined && filter.length > 0
    }

    const doDeleteDocument = (documentId: string) => {
        deleteClientDocument(clientId, documentId)
            .then((r) => {
                if (r.ok) {
                    load();
                } else {
                    console.log("failed to delete document");
                }
            })
            .catch((e) => {
                console.log(e);
            })
    }

    const doReminder = (documentId: string, esignDocumentId: string) => {


        getEsignProfiles()
            .then((ps) => {
                let profile = ps.filter((p) => p.name === "Promises12")[0];
                getCustomerDocumentKey(profile.uuid, documentId)
                    .then((k) => {
                        setSignReminderLoading(documentId);
                        pendingCustomerDocumentOnClientReminder(clientId, documentId, {
                            esignDocumentId: esignDocumentId,
                            esignDocumentKey: k.uuid,
                            esignProfileId: profile.uuid
                        })
                            .then((r) => {
                                if (r.ok) {
                                    load();
                                } else {
                                    console.log("failed to send reminder");
                                }
                            })
                            .catch((e) => {
                                console.log(e);
                            })
                            .finally(() => setSignReminderLoading(""))
                    })
                    .catch(e => {
                        console.log(e);
                    })
            })
            .catch(e => {
                console.log(e);
            });


    }


    const doDocumentShare = (documentId: string, esignDocumentId: string) => {


        getEsignProfiles()
            .then((ps) => {
                let profile = ps.filter((p) => p.name === "Promises12")[0];
                getCustomerDocumentKey(profile.uuid, documentId)
                    .then((k) => {
                        setSignReminderLoading(documentId);
                        shareDocumentWithClient(clientId, documentId, {
                            esignDocumentId: esignDocumentId,
                            esignDocumentKey: k.uuid,
                            esignProfileId: profile.uuid
                        })
                            .then((r) => {
                                if (r.ok) {
                                    load();
                                } else {
                                    console.log("failed to send reminder");
                                }
                            })
                            .catch((e) => {
                                console.log(e);
                            })
                            .finally(() => setSignReminderLoading(""))
                    })
                    .catch(e => {
                        console.log(e);
                    })
            })
            .catch(e => {
                console.log(e);
            });


    }

    return (<>
        <div className={"row"}>
            <div className={"col-lg-12 mb-3 "}>
                <h2>Client</h2>
            </div>

            <form>

                <div className={"col-lg-12 mb-3 "}>
                    <h5>Account Information</h5>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <button hidden={disabled} type={"button"} className={"btn btn-sm btn-danger mr-3"}
                            onClick={(e) => {
                                e.preventDefault();
                                disableClient(clientId)
                                    .then((r) => {
                                        if (r.ok) {
                                            setDoReload(true);
                                        }
                                    });
                            }}>
                        Disable
                    </button>
                    <button hidden={!disabled} type={"button"} className={"btn btn-sm btn-danger mr-3"}
                            onClick={(e) => {
                                e.preventDefault();
                                enableClient(clientId)
                                    .then((r) => {
                                        if (r.ok) {
                                            setDoReload(true);
                                        }
                                    });
                            }}>
                        Enable
                    </button>
                    <button hidden={editMode} type={"button"} className={"btn btn-sm btn-primary mr-3"}
                            onClick={(e) => {
                                e.preventDefault();
                                setEditMode(true);
                            }}
                    >
                        Edit
                    </button>
                    <button hidden={!editMode} type={"button"} className={"btn btn-sm btn-primary mr-3"}
                            onClick={(e) => {
                                e.preventDefault();
                                doEdit();
                            }}
                    >
                        Save
                    </button>
                    <Link to={"/m/export-client-file/" + clientId} target={"_blank"}>
                        <button type={"button"} className={"btn btn-sm btn-primary mr-3"}>
                            Export Client File
                        </button>
                    </Link>
                    <Link to={"/m/clients/share/" + clientId}>
                        <button type={"button"} className={"btn btn-sm btn-primary mr-3"}>
                            Share Link
                        </button>
                    </Link>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">ID</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={true}
                                   value={id}/>
                        </div>
                    </div>
                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">First Name</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={firstName} onChange={(e) => setFirstName(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Last Name</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={lastName} onChange={(e) => setLastName(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Email</label>
                            <input type="email" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={email} onChange={(e) => setEmail(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">SSN</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={ssn} onChange={(e) => setSsn(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Driver's License State</label>
                            <select id="inputState" className="form-control" disabled={!editMode}
                                    value={dlState} onChange={(e) => setDlState(e.target.value)}>
                                <option value={""}>Choose...</option>
                                <option value={"NC"}>NC</option>
                                <option value="AL">AL</option>
                                <option value="AK">AK</option>
                                <option value="AZ">AZ</option>
                                <option value="AR">AR</option>
                                <option value="CA">CA</option>
                                <option value="CO">CO</option>
                                <option value="CT">CT</option>
                                <option value="DE">DE</option>
                                <option value="DC">DC</option>
                                <option value="FL">FL</option>
                                <option value="GA">GA</option>
                                <option value="HI">HI</option>
                                <option value="ID">ID</option>
                                <option value="IL">IL</option>
                                <option value="IN">IN</option>
                                <option value="IA">IA</option>
                                <option value="KS">KS</option>
                                <option value="KY">KY</option>
                                <option value="LA">LA</option>
                                <option value="ME">ME</option>
                                <option value="MD">MD</option>
                                <option value="MA">MA</option>
                                <option value="MI">MI</option>
                                <option value="MN">MN</option>
                                <option value="MS">MS</option>
                                <option value="MO">MO</option>
                                <option value="MT">MT</option>
                                <option value="NE">NE</option>
                                <option value="NV">NV</option>
                                <option value="NH">NH</option>
                                <option value="NJ">NJ</option>
                                <option value="NM">NM</option>
                                <option value="NY">NY</option>
                                <option value="ND">ND</option>
                                <option value="OH">OH</option>
                                <option value="OK">OK</option>
                                <option value="OR">OR</option>
                                <option value="PA">PA</option>
                                <option value="RI">RI</option>
                                <option value="SC">SC</option>
                                <option value="SD">SD</option>
                                <option value="TN">TN</option>
                                <option value="TX">TX</option>
                                <option value="UT">UT</option>
                                <option value="VT">VT</option>
                                <option value="VA">VA</option>
                                <option value="WA">WA</option>
                            </select>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Driver's License Number</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={dlNumber} onChange={(e) => setDlNumber(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Date of Birth</label>
                            <input type="date" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={dateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Telephone Number</label>
                            <input type="tel" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={telephone} onChange={(e) => setTelephone(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <h6>Client Address</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Address Line 1</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={addressLine1} onChange={(e) => setAddressLine1(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Address Line 2</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={addressLine2} onChange={(e) => setAddressLine2(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">City</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={city} onChange={(e) => setCity(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">State</label>
                            <select id="inputState" className="form-control" disabled={!editMode}
                                    value={stateCode} onChange={(e) => setStateCode(e.target.value)}>
                                <option value={""}>Choose...</option>
                                <option value={"NC"}>NC</option>
                                <option value="AL">AL</option>
                                <option value="AK">AK</option>
                                <option value="AZ">AZ</option>
                                <option value="AR">AR</option>
                                <option value="CA">CA</option>
                                <option value="CO">CO</option>
                                <option value="CT">CT</option>
                                <option value="DE">DE</option>
                                <option value="DC">DC</option>
                                <option value="FL">FL</option>
                                <option value="GA">GA</option>
                                <option value="HI">HI</option>
                                <option value="ID">ID</option>
                                <option value="IL">IL</option>
                                <option value="IN">IN</option>
                                <option value="IA">IA</option>
                                <option value="KS">KS</option>
                                <option value="KY">KY</option>
                                <option value="LA">LA</option>
                                <option value="ME">ME</option>
                                <option value="MD">MD</option>
                                <option value="MA">MA</option>
                                <option value="MI">MI</option>
                                <option value="MN">MN</option>
                                <option value="MS">MS</option>
                                <option value="MO">MO</option>
                                <option value="MT">MT</option>
                                <option value="NE">NE</option>
                                <option value="NV">NV</option>
                                <option value="NH">NH</option>
                                <option value="NJ">NJ</option>
                                <option value="NM">NM</option>
                                <option value="NY">NY</option>
                                <option value="ND">ND</option>
                                <option value="OH">OH</option>
                                <option value="OK">OK</option>
                                <option value="OR">OR</option>
                                <option value="PA">PA</option>
                                <option value="RI">RI</option>
                                <option value="SC">SC</option>
                                <option value="SD">SD</option>
                                <option value="TN">TN</option>
                                <option value="TX">TX</option>
                                <option value="UT">UT</option>
                                <option value="VT">VT</option>
                                <option value="VA">VA</option>
                                <option value="WA">WA</option>
                            </select>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Zip</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={zip} onChange={(e) => setZip(e.target.value)}/>
                        </div>
                    </div>

                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <h6>Assessment</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={assessmentDate} onChange={(e) => setAssessmentDate(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Time</label>
                            <input type="time" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={assessmentTime} onChange={(e) => setAssessmentTime(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Recommended Hours</label>
                            <input type="number" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={recommendedHours} onChange={(e) => setRecommendedHours(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <div className="form-row align-items-center">
                            <label htmlFor="inputEmail4">Client Diagnosis</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={clientDiagnosis} onChange={(e) => setClientDiagnosis(e.target.value)}/>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Drug Test Due Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={drugTestDueDate} onChange={(e) => setDrugTestDueDate(e.target.value)}/>
                        </div>
                    </div>
                </div>
            </form>

            <div className={"col-lg-12 "}>
                <div
                    className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"></div>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <h5>Transactions</h5>
                <h6>Balance: {currencyFormat.format(balance)}</h6>
                <Link to={"/m/clients/" + clientId + "/charges/add"}>
                    <button className={"btn btn-primary btn-sm mr-3"}>Add Charge</button>
                </Link>
                <Link to={"/m/clients/" + clientId + "/payments/add"}>
                    <button className={"btn btn-primary btn-sm"}>Add Payment</button>
                </Link>
            </div>
            <div className={"col-lg-6 mb-3 "}>
                <Table headers={["Item", "Type", "Amount", "Transaction Date"]}
                       defaultPaginationSize={10}>
                    {transactions.map((t) => (
                        <tr key={t.uuid}>
                            <td>
                                <Link to={"/m/clients/" + clientId + "/" + t.type.toLowerCase() + "s/view/" + t.uuid}>
                                    {t.description}
                                </Link>
                            </td>
                            <td>{t.type}</td>
                            <td>{
                                (t.type === "CHARGE") ?
                                    currencyFormat.format(t.amount) :
                                    "(" + currencyFormat.format(t.amount) + ")"
                            }</td>
                            <td>{dateFormat(format.parse("yyyy-MM-dd", t.createdAt), "yyyy/mm/dd")}</td>
                            <td>
                                <a href={"/m/receipt/clients/" + clientId + (t.type === "CHARGE" ? "/charges/" : "/payments/") + t.uuid}
                                   target={"_blank"}>
                                    <button className={"btn btn-sm btn-primary"}>Print</button>
                                </a>
                                <button hidden={t.type === "CHARGE"} className={"btn btn-sm btn-primary ml-1"}

                                        onClick={() => {
                                            setReceiptLoading(t.uuid)
                                            sendPaymentReceipt(clientId, t.uuid)
                                                .then(r => {
                                                })
                                                .catch((e) => console.error(e))
                                                .finally(() => setReceiptLoading(""));
                                        }}>
                                    <span hidden={receiptLoading !== t.uuid}
                                          className="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                    Resend Receipt
                                </button>
                            </td>
                        </tr>
                    ))}
                </Table>
            </div>


            <div className={"col-lg-12 "}>
                <div
                    className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"></div>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <h5>Files, Forms, and Notes</h5>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <ul className={"quick-form"}>
                    <li className={isFormComplete("Form - Client Contact Record") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Client Contact Record")
                        }}>
                            Client contact record
                        </a>
                    </li>
                    <li className={isFormComplete("Form - Telehealth Release") ? "checked" : "unchecked"}
                    >
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Telehealth Release")
                        }}>
                            Telehealth release
                        </a>
                    </li>
                    <li className={isFormComplete("Form - Screening Tool") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Screening Tool")
                        }}>
                            Screening tool
                        </a>
                    </li>
                    <li className={isFormComplete("Form - Client Rights and Grievances") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Client Rights and Grievances")
                        }}>
                            Client rights, responsibilities and grievances
                        </a>
                    </li>
                    <li className={isFormComplete("Form - Service Agreement") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Service Agreement")
                        }}>
                            Service agreement
                        </a>
                    </li>
                    <li className={isFormComplete("Form - PROMISES12 Recommendation") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - PROMISES12 Recommendation")
                        }}>
                            Recommendation
                        </a>
                    </li>
                    <li className={isFormComplete("Form - Authorization for Care") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Authorization for Care")
                        }}>
                            Authorization for care
                        </a>
                    </li>
                    <li className={isFormComplete("Form - ROI Consent") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - ROI Consent")
                        }}>
                            ROI Release
                        </a>
                    </li>
                    <li className={isFormComplete("Form - 20-39 Hour Tx Plan") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - 20-39 Hour Tx Plan")
                        }}>
                            20-39 hour treatment plan
                        </a>
                    </li>
                    <li className={isFormComplete("Form - Screening Assessment and Orientation") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Screening Assessment and Orientation")
                        }}>
                            Assessment and Orientation
                        </a>
                    </li>
                    <li className={isFormComplete("Form - Addendum to Assessment") ? "checked" : "unchecked"}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            doQuickAddForm("Form - Addendum to Assessment")
                        }}>
                            Addendum
                        </a>
                    </li>
                </ul>
            </div>
            <div className={"col-lg-6 mb-3 "}>

                <div className="input-group">
                    <select className="custom-select" id="inputGroupSelect04"
                            aria-label="Example select with button addon"
                            value={form} onChange={(e) => setForm(e.target.value)}>
                        <option value={""}>Choose a form...</option>
                        {
                            templates?.map((t) => (
                                <option key={t.uuid} value={t.uuid}>{t.name}</option>
                            ))
                        }
                    </select>
                    <div className="input-group-append">
                        <button className="btn btn-primary" type="button" disabled={false} onClick={(e) => {
                            e.preventDefault();
                            doAddForm();
                        }}>Add Form
                        </button>
                    </div>
                </div>


            </div>

            <div className={"col-lg-6 mb-3 "}>

                <div className="input-group mb-3">
                    <div className="custom-file">
                        <input type="file" className="" id="inputGroupFile02" disabled={artifactUploading}
                               onChange={e => {
                                   setArtifact(e.target?.files?.[0]);
                               }}/>
                        <label className="custom-file-label" htmlFor="inputGroupFile02"
                               aria-describedby="inputGroupFileAddon02"
                               style={{fontSize: 16}}>{(artifact !== undefined) ? artifact.name : "Choose file to upload"}</label>
                    </div>
                    <div className="input-group-append">
                        <button className="btn btn-primary" type="button" id="inputGroupFileAddon04"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setDoUpload(true);
                                }}
                                disabled={artifactUploading}>Upload File
                        </button>
                    </div>
                    <div hidden={!artifactUploading} className="spinner-border" role="status">
                        <span className="sr-only">Uploading file...</span>
                    </div>
                </div>

            </div>

            <div className={"col-lg-12 mb-3 "}>
                <Table headers={["Name", "Type", "Description", "Status", "Created Date"]}
                       defaultPaginationSize={10}>
                    {
                        documents?.map((d) => (
                            <tr key={d.uuid}>
                                <td>
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (d.type.toLowerCase() !== "upload") {
                                                doOpenDocument(d.uuid, d.status, d.url);
                                            } else {
                                                doDownloadFile(d.url, d.name);
                                            }
                                        }}
                                        href={"#"}
                                    >
                                        {d.name}
                                    </a>
                                </td>
                                <td>{d.type}</td>
                                <td>{d.description}</td>
                                <td>{d.status}</td>
                                <td>{dateFormat(format.parse("yyyy-MM-ddThh:mm:ss", d.createdAt), "yyyy-mm-dd")}</td>
                                <td className={"text-right"}>
                                    <button hidden={d.status !== "PENDING_CLIENT_SIGNATURE"}
                                            className={"btn btn-sm btn-info mr-3"} type={"button"}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                let split = d.url.split("/")
                                                if(split.length === 6) {
                                                    doReminder(d.uuid, split[5]);
                                                }
                                            }}
                                    >

                                        Send Reminder
                                        <span hidden={d.uuid !== signReminderLoading} className="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
                                    </button>
                                    <button hidden={d.status !== "COMPLETE" || d.type === "UPLOAD"}
                                            className={"btn btn-sm btn-info mr-3"} type={"button"}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                let split = d.url.split("/")
                                                if(split.length === 6) {
                                                    doDocumentShare(d.uuid, split[5]);
                                                }
                                            }}
                                    >

                                        Send to Client
                                        <span hidden={d.uuid !== signReminderLoading} className="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
                                    </button>
                                    <button className={"btn btn-sm btn-danger"} type={"button"}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                doDeleteDocument(d.uuid);
                                            }}
                                    >Delete
                                    </button>

                                </td>
                            </tr>
                        ))
                    }

                    {
                        legacyDocuments?.map((d) => (
                            <tr key={"ld_" + d.id}>
                                <td>
                                    <Link to={"/m/export/" + d.id} target={"_blank"}

                                    >
                                        {d.name}
                                    </Link>
                                </td>
                                <td>Imported</td>
                                <td>EasySA imported document</td>
                                <td>Completed</td>
                                <td>{dateFormat(format.parse("yyyy-MM-dd", d.createdAt), "yyyy-mm-dd")}</td>
                                <td></td>
                            </tr>
                        ))
                    }
                    {
                        legacyNotes?.map((d) => (
                            <tr key={"ld_" + d.id}>
                                <td>
                                    <Link to={"/m/export-note/" + d.id} target={"_blank"}

                                    >
                                        {d.sessionTopic}
                                    </Link>
                                </td>
                                <td>Imported</td>
                                <td>EasySA imported note</td>
                                <td>{d.sessionStatus}</td>
                                <td>{dateFormat(format.parse("yyyy-MM-dd", d.sessionDate), "yyyy-mm-dd")}</td>
                                <td></td>
                            </tr>
                        ))
                    }
                </Table>
            </div>

            <div className={"col-lg-12 mb-3 "}>
                <h5>Attendance</h5>
                <p>Summary: Total hours attended: {totalHoursAttended}, absences: {absences}</p>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <Table headers={["Session Date", "Attended"]}
                       defaultPaginationSize={25}>
                    {
                        attendances.filter(a => a.signed).map((a) => (
                            <tr key={a.therapySession.uuid}>
                                <td>
                                    <Link to={"/m/therapy-sessions/view/" + a.therapySession.uuid}>
                                        {a.therapySession.date}
                                    </Link>
                                </td>
                                <td>
                                    {(a.attended) ? "Yes" : "No"}
                                </td>
                                <td>

                                </td>
                            </tr>
                        ))
                    }

                </Table>
            </div>

            <div className={"col-lg-12 mb-3 "}>
                <Link to={"/m/clients"}>
                    <button type={"button"} className={"btn btn-primary mr-3"}>
                        Back to Clients
                    </button>
                </Link>

            </div>
        </div>

        <Modal show={showUploadFileModal} title={"Upload File"} cancelButtonText={"Cancel"}
               okButtonText={"Save"}
               doCancel={() => {
                   setShowUploadFileModal(false);
               }}
               doOk={() => {
                   setShowUploadFileModal(false);
               }}>
            <p>aaaa</p>
        </Modal>
    </>);
};

export default ViewClient;